import { render } from "./ChatBox.vue?vue&type=template&id=720cfbf6&bindings={}"
import script from "./ChatBox.vue?vue&type=script&lang=ts"
export * from "./ChatBox.vue?vue&type=script&lang=ts"

import "./ChatBox.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script